import React from 'react'
import newsletterConfig from '../../../newsletter-config.json'
import mapNewsletterItems from '../functions/mapNewsletterItems'
import { NewsletterSectionRow, TableWrapper } from './helpersComponents'
import NewsletterTranslation from './NewsletterTranslation'


const NewsletterSectionImage = ({id, newsletterData, stylesData, items, translation}) => {
    const components = []
    const imgBorderRadius = stylesData.posterRadius ? stylesData.posterRadius : 0

    return (
        mapNewsletterItems(id, newsletterData, items, (components, itemData, index) => {
            const { img } = itemData
            let imageUrl = false
            let imageAlt = <NewsletterTranslation id="print_newsletter_preview_no_alt_text" translation={translation}>Kein alt Text vorhanden</NewsletterTranslation>

            if(img) {
                imageUrl = img.url ? img.url : null
                imageAlt = img.alt ? img.alt : <NewsletterTranslation id="print_newsletter_preview_no_alt_text" translation={translation}>Kein alt Text vorhanden</NewsletterTranslation>
            }

            components.push(
                <NewsletterSectionRow key={index + '-text'}>
                    <TableWrapper>
                        {imageUrl && <tr>
                            <td className="imageContent" align="Left" valign="top" style={{paddingTop: "80px", paddingBottom: "11px"}}>
                                <img className="flexibleImage" alt={imageAlt} src={imageUrl} width={newsletterConfig.bodyWith}  style={{maxWidth: newsletterConfig.bodyWith, height: "auto", borderRadius: imgBorderRadius}}/>
                            </td>
                        </tr>}
                    </TableWrapper>
                </NewsletterSectionRow>
            )
        }, components)
    )
}

export default NewsletterSectionImage

